export const product_Loading_status = "product_Loading_status";

export const product_Success_status = "product_Success_status";

export const product_Error_status = "product_Error_status";
